import React from 'react';
import PropTypes from 'prop-types';
import FormattedLink from '@stubhub/react-formatted-link';
import controller from './sub-category-controller';
import {ssr_wait, connect} from '@stubhub/react-store-provider';

import '../styles/nav-sub-category.scss';

const categoryConfig = {
  "sports": 28,
  "concerts": 1,
  "theater-comedy": 174
};

export class NavSubCategoryList extends React.Component {
  static contextTypes = {
    globalRegistry: PropTypes.object
  };

  @ssr_wait
  init() {
    let {id} = this.props;
    return this.props.loadCategoryData(categoryConfig[id]);
  }

  processApiResp(rawData) {
    let processedData = rawData.map((event) => {
      let perfObj;
      perfObj = (event.performers && event.performers[0]) || (event.performersCollection && event.performersCollection[0]);
      
      // Some API responses are missing ancestor data that is critical to letting us to create a menu option
      if (perfObj) {
        return {"name": perfObj.name, "webURI": `/${perfObj.url}/performer/${perfObj.id}`};
      } else {
        return null;
      }
    });
    return processedData;
  }

  // Returns an array of divs that represent each sub cat option
  generateDropdownOptions(data, id, columnIndex, onOptionClick) {
    let selectedTopNav = data[id] || data;
    let categoryNavOptions = selectedTopNav.map((item, index) => {
      let {name, webURI} = item;
      return (
        <div className="subCat--option" key={index}>
          <FormattedLink className="subCat--option-link" href={webURI} data-index={index} data-id={id} data-columnindex={columnIndex} onClick={onOptionClick}>{name}</FormattedLink>
        </div>
      );
    });
    return categoryNavOptions;
  }

  // Returns a column of sub category options
  createSubCatColumn(columnItems, uniqueClassName, categoryId, showHeading = false) {
    let className = `mh__nav-subCat-col ${uniqueClassName}`;
    // @TODO: Headings need to be localized
    let geoHeadingMsg = categoryId === "sports" ? "Local teams" : "Popular near you";
    let geoHeading = showHeading ? (<div className="subCat--heading">{geoHeadingMsg}</div>) : null;
    return (
      <div className={className}>
        {geoHeading}
        {columnItems}
      </div>
    );
  }

  handleDocumentClick = (e) => {
    // This function is attached to the document object which cannot be replicated in unit tests
    /* istanbul ignore next */
    if (this.rootNode.parentNode && !this.rootNode.parentNode.contains(e.target)) {
      // User clicked outside of this component
      if (this.props.onClickOutside) {
        this.props.onClickOutside.call(this);
      }
    }
  }

  UNSAFE_componentWillMount() {
    this.init();
  }

  componentDidMount() {
    // We only need to attach listener for the topmost instance
    // Cannot mock missing document
    /* istanbul ignore next */
    if (document) {
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('mouseout', this.handleDocumentClick);
    }
  }

  componentWillUnmount() {
    // Cannot mock missing document
    /* istanbul ignore next */
    if (document) {
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('mouseout', this.handleDocumentClick);
    }
    this.props.resetSubCatDropdown();
  }

  render() {
    let {onOptionClick, id, categoryData, merchConfig, location} = this.props;

    let firstColumn, secondColumn;
    if (merchConfig) {
      let primaryCategoryOptions = this.generateDropdownOptions(merchConfig, id, 0, onOptionClick);
      firstColumn = this.createSubCatColumn(primaryCategoryOptions, "first-col");

      // Only initialize the second column if geo is set and data is available from API
      if (categoryData.length !== 0 && location) {
        let processedData = this.processApiResp(categoryData);
        processedData = processedData.filter(Boolean);
        let secondaryCategoryOptions = this.generateDropdownOptions(processedData, id, 1, onOptionClick);
        secondColumn = this.createSubCatColumn(secondaryCategoryOptions, "second-col", id, true);
      }

      let subCatNavContent = (
        <div className="mh__nav-sub-category">
          {firstColumn}
          {secondColumn}
        </div>
      );
      return <div ref={(node) => this.rootNode = node}>{subCatNavContent}</div>;
    } else {
      return <div ref={(node) => this.rootNode = node}></div>;
    }
  }
}

NavSubCategoryList.propTypes = {
  id: PropTypes.string.isRequired,
  resetSubCatDropdown: PropTypes.func.isRequired,
  categoryData: PropTypes.array,
  merchConfig: PropTypes.array,
  onOptionClick: PropTypes.func,
  onClickOutside: PropTypes.func
};

export default connect(controller)(NavSubCategoryList);
